var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0852 3.33471L5.08719 7.55351V15.9791H4.08719V8.39751L2.70959 9.56031L2.06439 8.79671L10.0892 2.02231L18.012 8.79871L17.3616 9.55831L16.0872 8.46831V15.9791H15.0872V7.61311L10.0852 3.33471Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.08731 9.97763H13.0873V16.9776H17.9873V17.9776H1.9873V16.9776H7.08731V9.97763ZM12.0873 10.9776H8.08731V16.9776H12.0873V10.9776Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon-home.205a04850578330aece00b75b7dd62a0.svg";
export { ForwardRef as ReactComponent };